import { render, staticRenderFns } from "./BufferItemList.vue?vue&type=template&id=0f4bb929&scoped=true&"
import script from "./BufferItemList.vue?vue&type=script&lang=js&"
export * from "./BufferItemList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4bb929",
  null
  
)

export default component.exports